<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'change-password-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="position-relative w-100 h-100 text-center mt-2 mb-1">
            <img :src="forgetPasswordImg" alt="forgetPasswordImg" width="180" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div
            class="text-header font-large-1 text-bold text-black text-center"
          >
            Create New Password
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="m-auto">
            <b-form
              id="change-password"
              @submit.prevent="onSubmitChangePassword()"
            >
              <div class="add-on-border-group mt-10px">
                <div class="font-medium-5 required">Current Password</div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model="formData.currentPassword"
                    :type="formData.currentPasswordFieldType"
                    :formatter="onCheckPasswordFormat"
                    placeholder="Current Password"
                    class="add-on-border-input"
                    id="current-password"
                    name="current-password"
                    autocomplete="current password"
                    @input="onCheckPasswordMatchOld"
                  />
                  <b-input-group-append is-text class="add-on-border">
                    <button
                      type="button"
                      class="btn-show-password"
                      @click="
                        onTogglePasswordVisibility(
                          passwordToggle.CURRENT_PASSWORD
                        )
                      "
                    >
                      <show-password
                        class="icon-show-password-svg"
                        v-if="formData.currentPasswordFieldType === 'password'"
                      />
                      <hide-password class="icon-show-password-svg" v-else />
                    </button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div class="add-on-border-group mt-10px">
                <div class="font-medium-5 required">New Password</div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model="formData.newPassword"
                    :type="formData.newPasswordFieldType"
                    :formatter="onCheckPasswordFormat"
                    placeholder="New Password"
                    class="add-on-border-input"
                    id="new-password"
                    name="new-password"
                    autocomplete="current password"
                    @input="onCheckValidatePassword"
                  />
                  <b-input-group-append is-text class="add-on-border">
                    <button
                      type="button"
                      class="btn-show-password"
                      @click="
                        onTogglePasswordVisibility(passwordToggle.NEW_PASSWORD)
                      "
                    >
                      <show-password
                        class="icon-show-password-svg"
                        v-if="formData.newPasswordFieldType === 'password'"
                      />
                      <hide-password class="icon-show-password-svg" v-else />
                    </button>
                  </b-input-group-append>
                </b-input-group>
                <div
                  class="font-medium-5 text-danger"
                  v-if="passwordValidate.matchOld"
                >
                  New password can not be the same as current password
                </div>
              </div>
              <div class="add-on-border-group mt-10px">
                <div class="font-medium-5 required">Confirm New Password</div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model="formData.confirmNewPassword"
                    :type="formData.confirmPasswordFieldType"
                    :formatter="onCheckPasswordFormat"
                    placeholder="Confirm New Password"
                    class="add-on-border-input"
                    id="confirm-password"
                    name="confirm-password"
                    autocomplete="current password"
                    @input="onCheckPasswordMatch"
                  />
                  <b-input-group-append is-text class="add-on-border">
                    <button
                      type="button"
                      class="btn-show-password"
                      @click="
                        onTogglePasswordVisibility(
                          passwordToggle.CONFIRM_NEW_PASSWORD
                        )
                      "
                    >
                      <show-password
                        class="icon-show-password-svg"
                        v-if="formData.confirmPasswordFieldType === 'password'"
                      />
                      <hide-password class="icon-show-password-svg" v-else />
                    </button>
                  </b-input-group-append>
                </b-input-group>
                <div class="text-error-wrp">
                  <div id="show-text-error">
                    <div>Error Message</div>
                  </div>
                </div>
              </div>
              <div class="add-on-border-group mt-10px">
                <div class="content-policy container mt-1">
                  <div class="row">
                    <div class="col-12">
                      <div class="font-medium-5 text-black text-bold">
                        Password must contain:
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-1">
                          <div class="font-medium-4 text-black">
                            <img
                              v-if="passwordValidate.passwordLength != null"
                              :src="
                                passwordValidate.passwordLength == true
                                  ? ValidIcon
                                  : passwordValidate.passwordLength == false
                                  ? InvalidIcon
                                  : ''
                              "
                              width="15"
                              height="15"
                            />
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="font-medium-5 text-black">
                            At least 8 characters
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <div class="font-medium-4 text-black">
                            <img
                              v-if="passwordValidate.oneLower != null"
                              :src="
                                passwordValidate.oneLower == true
                                  ? ValidIcon
                                  : passwordValidate.oneLower == false
                                  ? InvalidIcon
                                  : ''
                              "
                              width="15"
                              height="15"
                            />
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="font-medium-5 text-black">
                            At least one lowercase letter (a-z).
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <div class="font-medium-4 text-black">
                            <img
                              v-if="passwordValidate.oneUpper != null"
                              :src="
                                passwordValidate.oneUpper == true
                                  ? ValidIcon
                                  : passwordValidate.oneUpper == false
                                  ? InvalidIcon
                                  : ''
                              "
                              width="15"
                              height="15"
                            />
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="font-medium-5 text-black">
                            At least one uppercase letter (A -Z).
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <div class="font-medium-4 text-black">
                            <img
                              v-if="passwordValidate.oneDigit != null"
                              :src="
                                passwordValidate.oneDigit == true
                                  ? ValidIcon
                                  : passwordValidate.oneDigit == false
                                  ? InvalidIcon
                                  : ''
                              "
                              width="15"
                              height="15"
                            />
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="font-medium-5 text-black">
                            At least one number (0-9)
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <div class="font-medium-4 text-black">
                            <img
                              v-if="passwordValidate.oneSpecial != null"
                              :src="
                                passwordValidate.oneSpecial == true
                                  ? ValidIcon
                                  : passwordValidate.oneSpecial == false
                                  ? InvalidIcon
                                  : ''
                              "
                              width="15"
                              height="15"
                            />
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="font-medium-5 text-black">
                            At least one special character
                            (!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~)
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <div class="font-medium-4 text-black">
                            <img
                              v-if="passwordValidate.match != null"
                              :src="
                                passwordValidate.match == true
                                  ? ValidIcon
                                  : passwordValidate.match == false
                                  ? InvalidIcon
                                  : ''
                              "
                              width="15"
                              height="15"
                            />
                          </div>
                        </div>
                        <div class="col-11">
                          <div class="font-medium-5 text-black">
                            Password must be match
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="m-3 text-center">
                <diV class="container">
                  <div class="row">
                    <div class="col">
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="mr-2">
                          <cancel-button
                            @click.native="$emit('onCloseModal')"
                          />
                        </div>
                        <div>
                          <b-button
                            type="submit"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="success"
                            :disabled="!resolveResetPasswordButton"
                            ><div class="font-medium-5">Reset Password</div>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </diV>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </base-modal>
</template>

<script>
import ChangeBrand from "@/@core/components/svg/common/ChangeBrand.vue";
import ShowPassword from "@/@core/components/svg/common/ShowPassword.vue";
import HidePassword from "@/@core/components/svg/common/HidePassword.vue";
import ChangePasswordSvg from "@/@core/components/svg/common/ChangePassword.vue";
import ValidIcon from "@/assets/images/icons/valid.png";
import InvalidIcon from "@/assets/images/icons/invalid.png";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";

import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
} from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import forgetPasswordImg from "@/assets/images/pages/forgor-password/Forgot-Passwordl-BP.png";
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ShowPassword,
    HidePassword,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  setup(props, { emit }) {
    const formData = reactive({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      currentPasswordFieldType: "password",
      newPasswordFieldType: "password",
      confirmPasswordFieldType: "password",
      changePassword: false,
    });

    const passwordValidate = reactive({
      passwordLength: null,
      oneLower: null,
      oneUpper: null,
      oneDigit: null,
      oneSpecial: null,
      matchOld: null,
      match: null,
    });

    const passwordToggle = {
      CURRENT_PASSWORD: 1,
      NEW_PASSWORD: 2,
      CONFIRM_NEW_PASSWORD: 3,
    };

    const onTogglePasswordVisibility = (password) => {
      switch (password) {
        case passwordToggle.CURRENT_PASSWORD:
          formData.currentPasswordFieldType =
            formData.currentPasswordFieldType === "password"
              ? "text"
              : "password";
          break;
        case passwordToggle.NEW_PASSWORD:
          formData.newPasswordFieldType =
            formData.newPasswordFieldType === "password" ? "text" : "password";
          break;
        case passwordToggle.CONFIRM_NEW_PASSWORD:
          formData.confirmPasswordFieldType =
            formData.confirmPasswordFieldType === "password"
              ? "text"
              : "password";
          break;
        default:
      }
    };

    const onCheckValidatePassword = (password) => {
      if (!password) return;

      passwordValidate.passwordLength = true;
      passwordValidate.oneLower = true;
      passwordValidate.oneUpper = true;
      passwordValidate.oneDigit = true;
      passwordValidate.oneSpecial = true;
      passwordValidate.matchOld = false;
      passwordValidate.match = false;

      if (password.length < 8) {
        passwordValidate.passwordLength = false;
      }
      if (password.search(/[a-z]/i) < 0) {
        passwordValidate.oneLower = false;
      }
      if (password.search(/[A-Z]/i) < 0) {
        passwordValidate.oneUpper = false;
      }
      if (password.search(/[0-9]/) < 0) {
        passwordValidate.oneDigit = false;
      }
      if (password.search(/[_~`!@#$%^&*()_+=[\]\{}|;':",./]/i) < 0) {
        passwordValidate.oneSpecial = false;
      }
      if (password && password == formData.currentPassword) {
        passwordValidate.matchOld = true;
      }
      if (password && password == formData.confirmNewPassword) {
        passwordValidate.match = true;
      }
    };

    const onCheckPasswordMatchOld = (password) => {
      if (!password) return;

      if (password == formData.newPassword) passwordValidate.matchOld = true;
      else passwordValidate.matchOld = false;
    };

    const onCheckPasswordMatch = (password) => {
      if (!password) return;

      if (password == formData.newPassword) passwordValidate.match = true;
      else passwordValidate.match = false;
    };

    const onCheckPasswordFormat = (password) => {
      const pass = password.replace(
        /[^a-zA-Z0-9-_~`!@#$%^&*()_+=[\]\{}|;':",./]/g,
        ""
      );
      return pass;
    };

    const resolveResetPasswordButton = computed(() => {
      if (
        passwordValidate.passwordLength &&
        passwordValidate.oneLower &&
        passwordValidate.oneUpper &&
        passwordValidate.oneDigit &&
        passwordValidate.oneSpecial &&
        passwordValidate.match &&
        !passwordValidate.matchOld
      )
        return true;
      return false;
    });

    const onSubmitChangePassword = () => {
      emit("onSubmit", formData);
    };

    return {
      formData,
      passwordToggle,
      passwordValidate,
      onTogglePasswordVisibility,
      onCheckPasswordFormat,
      onCheckValidatePassword,
      onCheckPasswordMatch,
      onCheckPasswordMatchOld,
      onSubmitChangePassword,
      resolveResetPasswordButton,
      ValidIcon,
      InvalidIcon,
      forgetPasswordImg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>

<style>
#change-password-modal .modal-header {
  display: none;
}

#change-password-modal .modal-content {
  border-radius: 1.6rem;
  height: auto;
}

#change-password-modal .modal-body {
  padding: 2rem 1.4rem;
  height: auto;
}

#change-password-modal .information-header {
  font-size: 2.4rem !important;
  width: 100%;
  border-bottom: 1px solid #ececec;
  padding: 5px 30px 10px;
  color: #000080;
}

#change-password-modal .icon-change-brand {
  width: 30px;
  height: 30px;
  fill: #000080;
}

#change-password-modal .content-body {
  padding: 0 30px;
  height: auto;
}

#change-password-modal .add-on-border-group {
  overflow: hidden;
  border-radius: 8px;
  width: 100% !important;
  margin: auto;
}

#change-password-modal .btn-show-password {
  border: none;
  background: none;
  padding: 0;
}

#change-password-modal .icon-show-password-svg {
  height: 24px;
  fill: #d8d6de;
}

#change-password-modal .btn-disabled {
  opacity: 0.6;
  cursor: no-drop;
  pointer-events: none;
}

#change-password-modal #show-text-error {
  visibility: hidden;
}

#change-password-modal #show-text-error.show {
  visibility: visible;
  position: relative;
  color: #ea5455;
  font-size: 18px;
}

#change-password-modal .text-error-wrp {
  height: 10px;
  position: absolute;
}

#change-password-modal .title-size {
  font-size: 22px;
}

#change-password-modal .mt-10px {
  margin-top: 10px;
}

#change-password-modal .text-header {
  /* border-bottom: 1px solid #dedede; */
  padding: 1rem;
}

#change-password-modal .content-policy {
  background-color: #f2f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
}

@media (min-width: 700px) {
  #change-password-modal .modal-lg,
  #change-password-modal .modal-xl {
    max-width: 650px;
  }
}

@media (min-width: 1300px) {
  #change-password-modal .modal-lg,
  #change-password-modal .modal-xl {
    max-width: 650px;
  }
}
</style>
